import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import {
    ApplicationDetail,
    type ApplicationDetailTab,
} from '../../pages/platform/applications/ApplicationDetail';

const TABS: ApplicationDetailTab[] = ['levels', 'catalog', 'roles', 'defaults'];

function isTab(value: unknown): value is ApplicationDetailTab {
    return typeof value === 'string' && (TABS as string[]).includes(value);
}

// Detalle/edición de una aplicación (#3-a, Task E): `/platform/applications/{id}`. Hereda el guard de
// scope PLATFORM del layout padre (_layout.platform); el backend re-enforza `platform.application.manage`
// en cada endpoint que tocan los tabs. La pestaña activa vive en el searchParam `?tab=` para que el
// deep-link y el refresh sean estables (default 'levels').
export const Route = createFileRoute(
    '/_authenticated/_layout/platform/applications/$applicationId',
)({
    // Gate de edición CONSISTENTE con el botón "Editar"/fila de ApplicationsTable (review #3-a E): el
    // detalle ES un editor (tabs con Guardar + CRUD del catálogo), así que exige
    // `platform.application.manage`, no solo scope PLATFORM del layout padre. Cubre también el acceso
    // por URL directa. Sin esto, un platform user sin la permission llegaba a un editor inutilizable.
    validateSearch: (search: Record<string, unknown>): { tab: ApplicationDetailTab } => ({
        tab: isTab(search.tab) ? search.tab : 'levels',
    }),
    beforeLoad: async ({ context }) => {
        const state = await context.auth.ensureLoaded();
        if (!state.permissions.has('platform.application.manage')) {
            throw redirect({ to: '/platform/applications' });
        }
    },
    component: ApplicationDetailRoute,
});

function ApplicationDetailRoute() {
    const { applicationId } = Route.useParams();
    const { tab } = Route.useSearch();
    const navigate = useNavigate();

    return (
        <ApplicationDetail
            applicationId={applicationId}
            tab={tab}
            onTabChange={(next) => {
                void navigate({
                    to: '/platform/applications/$applicationId',
                    params: { applicationId },
                    search: { tab: next },
                });
            }}
            onBack={() => {
                void navigate({ to: '/platform/applications' });
            }}
        />
    );
}
